export const CALENDAR_URL = "https://cal.com/mmaraqa-uniqreach/intro-call-30";
